import api from '../api/axiosInstance';
// src/api/authService.js
//@param {Object} credentials - { email: string, password: string }
//@returns {Promise<Object>} - { token, roles, email }
export const login = async (credentials) => {
    try {
        const response = await api.post('/auth/login', credentials);
        return response.data;
    } catch (error) {
        throw error.response?.data || { mensaje: 'Error desconocido al intentar autenticar.' };
    }
};
